import React, {Component} from 'react'
import BatchesPage from './BatchesPage'
import queryString from 'query-string'

class BatchesPageContainerV3 extends Component{
    render() {
        const {location} = this.props.history
        let params = {}

        if (location.search !== '') {
            params = queryString.parse(location.search)
        }

        return (
            <div className='LabelsPageContainer'>
                <BatchesPage {...params}/>
            </div>
        )
    }

}

export default BatchesPageContainerV3